/* BG COM : ajout rapide ?bgadd= (snippets/bgcom-ajout-rapide). Sorti du HTML le 03/10/2026, chargé en defer. */
(function(){
  if(window.BGADD)return;window.BGADD=1;
  var raw;try{raw=new URLSearchParams(location.search).get('bgadd');}catch(e){return;}
  if(!raw)return;
  try{var u=new URL(location.href);u.searchParams.delete('bgadd');history.replaceState(history.state,'',u.pathname+u.search+u.hash);}catch(e){}
  var items=raw.split(',').slice(0,30).map(function(x){var p=x.split(':'),id=parseInt(p[0],10),q=parseInt(p[1]||'1',10);return {id:id,quantity:Math.min(999,Math.max(1,q||1))};}).filter(function(i){return i.id>0;});
  if(!items.length)return;
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
  function post(list){return fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:list})}).then(function(r){return r.ok;}).catch(function(){return false;});}
  function toast(msg){
    var t=document.createElement('div');t.setAttribute('role','status');t.textContent=msg;
    t.style.cssText='position:fixed;left:50%;bottom:24px;z-index:2147483000;transform:translateX(-50%);max-width:min(92vw,520px);padding:12px 18px;border-radius:999px;background:#171717;color:#fff;font-family:inherit;font-size:14px;font-weight:600;line-height:1.35;box-shadow:0 12px 30px -12px rgba(0,0,0,.45);text-align:center';
    document.body.appendChild(t);setTimeout(function(){t.style.transition='opacity .4s';t.style.opacity='0';setTimeout(function(){t.remove();},450);},5200);
  }
  function openCart(){var n=0;(function tick(){if(typeof window.bgproOpen==='function'){window.bgproOpen();return;}if(++n>50){location.href=root+'cart';return;}setTimeout(tick,100);})();}
  function run(){
    post(items).then(function(ok){
      if(ok){openCart();return;}
      /* un produit indisponible fait échouer tout l'envoi : on réessaie un par un */
      var fails=0,i=0;
      (function next(){
        if(i>=items.length){if(fails<items.length)openCart();toast(fails===items.length?'Ces produits ne sont plus disponibles pour le moment.':(fails+' produit'+(fails>1?'s':'')+' indisponible'+(fails>1?'s':'')+', le reste est dans votre panier.'));return;}
        post([items[i++]]).then(function(o){if(!o)fails++;next();});
      })();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();
